import $, { css, get } from "jquery";
$(function () {
    function togglePopup(targeted_popup_class, action) {
        var popup = $('[data-popup="' + targeted_popup_class + '"]');
        if (action === 'open') {
            // Close other pop-ups
            $('[data-popup]').not(popup).fadeOut(350);
            
            popup.fadeIn(350);
            // Calculate the width of the scrollbar
            var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            $('body').css({
                'margin-right': scrollbarWidth + 'px'
            });
            // Add padding to compensate for scrollbar width
            $('body').addClass('body-no-scroll-compensate');
            $('body').addClass('body-no-scroll');
        } else if (action === 'close') {
            popup.fadeOut(350);
            // Remove class and padding to restore scrollbar
            $('body').removeClass('body-no-scroll');
            $('body').removeClass('body-no-scroll-compensate');
            $('body').css({
                'margin-right': ''
            });
        }
    }
    
    // Event handler for opening a popup
    $('[data-popup-open]').on('click', function (e) {
        var targeted_popup_class = $(this).attr('data-popup-open');
        togglePopup(targeted_popup_class, 'open');
        e.preventDefault();
    });
    

    // Event handler for closing a popup
    $('[data-popup-close]').on('click', function (e) {
        var targeted_popup_class = $(this).attr('data-popup-close');
        togglePopup(targeted_popup_class, 'close');
        e.preventDefault();
    });
});
